module.exports = __webpack_public_path__ + "img/phone.789cf0cc.svg";